import RadioButtonGroupModule from './radio-button-group.module'

export default RadioButtonGroupModule
